// extracted by mini-css-extract-plugin
var _1 = "src-js-platin-controllers-popup--ErrorTemplate-module__errorContainer";
var _2 = "src-js-platin-controllers-popup--ErrorTemplate-module__xIcon";
export { _1 as "errorContainer", _2 as "xIcon" }
